import React,  {Component} from 'react';
import PropTypes from 'prop-types'

export default class AlertPage extends Component{
    render(){
        return(
            <div style={styles.mainContainer}>
                <h1>{this.props.codeDesc} (#{this.props.code})</h1>
            
                <div style={styles.containerTitle}>
                    <p style={styles.title}>{this.props.title}</p>
                </div>

                <p>{this.props.message}</p>
            </div>
        );
    }
}

const styles = {
    mainContainer: {
        marginLeft: '20px'
    },    
    containerTitle: {
        backgroundColor: 'rgba(77, 99, 153, 0.5)',
        marginRight: '20px',
        paddingLeft: '12px',
        paddingTop: '1px',
        paddingBottom: '1px',
        borderRadius: '14px'
    },    
    title: {
        fontWeight: 'bold',
        color: 'white'
    }
};

AlertPage.propTypes  = {
    code: PropTypes.string,
    codeDesc: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string
}